import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const DiscoverCardSkeleton = styled.article`
	position: relative;
	overflow: hidden;
	width: 100%;
	height: clamp(600px, 78vh, 720px);
	margin-bottom: 18px;
	scroll-snap-align: start;
	border-radius: 24px;
	background: #070509;
	box-shadow: 0 18px 44px rgba(0, 0, 0, 0.42);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		height: 100dvh;
		min-height: 100dvh;
		margin-bottom: 0;
		border-radius: 0;
		box-shadow: none;
	}
`;

export const DiscoverCardSkeletonInfo = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
	padding: 0 24px 24px;
	display: flex;
	flex-direction: column;
	gap: 12px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 0 22px calc(88px + env(safe-area-inset-bottom, 0px));
	}
`;
